import styled from '@emotion/styled';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const ModalTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
  text-align: center;
`;

export const ModalIconWrapper = styled.div`
  text-align: center;
`;
